import HttpService from "@/utils/httpData"
// import { APP_CONFIG } from '@/utils/constants'
export const uploadImg = (fileData) => {
    // let self = this;
    let apiEndpoint = 'Training/UploadAvata';
    let file = fileData.target.files ? fileData.target.files[0] : null;
    if (file) {
        return HttpService.uploadFile(apiEndpoint, { images: file }).then(res => {
            return res.data && res.data ? res.data : null;

        }).catch(e => { return false });
    }

    return false;
}
// export const classList = (params = {}) => {
//     let apiEndpoint = `Book/BookFillter`;
//     return HttpService.post(apiEndpoint, params).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

// export const listExercise = params => {
//     let apiEndpoint = `practice/get-list`;
//     return HttpService.get(apiEndpoint, params).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

// export const getCategoriesByBook = id => {
//     let apiEndpoint = `practice/get-book-index?bookId=${id}`;
//     return HttpService.get(apiEndpoint).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }
// export const getLuggageNumber = (params = {}) => {
//     let apiEndpoint = `practice/get-practice-group-index`;
//     return HttpService.post(apiEndpoint, params).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }
// export const getListPracticeTypeBook = (params = {}) => {
//     let apiEndpoint = `practice/get-list-practice-type-book`;
//     return HttpService.post(apiEndpoint, params).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }
// export const practiceReportError = (params = { params }) => {
//     let apiEndpoint = `practice/ReportError`;
//     return HttpService.post(apiEndpoint, params).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

// export const getPracticeType = id => {
//     let apiEndpoint = `practice/get-practice-type?classId=${id}`;
//     return HttpService.get(apiEndpoint).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

// export const getQuestionsByCat = (bookId, bookIndexId) => {
//     let apiEndpoint = `practice/get-by-index?bookId=${bookId}&bookIndexId=${bookIndexId}`;
//     return HttpService.get(apiEndpoint).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

// export const getQuestionsSidebar = (bookIndexId, practiceGroupIndexId = 0) => {
//     let apiEndpoint = `practice/get-question-index?practiceGroupIndexId=${practiceGroupIndexId}&bookIndexId=${bookIndexId}`;
//     return HttpService.get(apiEndpoint).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }
export const getQuestionDetail = id => {
    let apiEndpoint = `practice/get-question?questionId=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

// export const getInfoBookBasic = id => {
//     let apiEndpoint = `practice/GetBook?bookId=${id}`;
//     return HttpService.get(apiEndpoint).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

// export const getInfoBookCatsForQuestions = id => {
//     let apiEndpoint = `practice/GetBookIndexById?bookIndexId=${id}`;
//     return HttpService.get(apiEndpoint).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

export const saveUserWorkQuestion = payload => {
    let apiEndpoint = `Answer/CreatePra`;
    return HttpService.post(apiEndpoint, {question: [payload]}).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

// Delete by bookIndexId
// export const resetUserWorkQuestionByBookIndexId = id => {
//     let apiEndpoint = `Answer/DeletePra`;
//     return HttpService.post(apiEndpoint, { id }).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }
// Delete by QuestionId
export const resetResultWorkQuestion = id => {
    let apiEndpoint = `Answer/DeletePraByQuestionId`;
    return HttpService.post(apiEndpoint, { id }).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

// export const resetResultWorkQuestionByQuestion = id => {
//     let apiEndpoint = `Answer/DeletePraByQuestionId`;
//     return HttpService.post(apiEndpoint, { id }).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

// export const getExamList = payload => {
//     let apiEndpoint = `Exam/GetListExamOtherPractice`;
//     return HttpService.post(apiEndpoint, payload).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

// export const getCatOfExerciseOtherOrThematic = payload => {
//     let apiEndpoint = `Exam/GetListChapterOtherPractice`;
//     return HttpService.post(apiEndpoint, payload).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

export const getQuestionsExam = examId => {
    let apiEndpoint = `Question/GetListQuestionOtherPracticeById?chapterId=0&examId=${examId}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

// export const getDetailOfOtherOrThematic = chapterId => {
//     let apiEndpoint = `exam/DetailChapter?chapterId=${chapterId}`;
//     return HttpService.get(apiEndpoint).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

// export const getQuestionListInSidebarOfThematicOrOther = (chapterId, examId = 0) => {
//     let queryParams = chapterId !== 0 ? `chapterId=${chapterId}` : `examId=${examId}`
//     let apiEndpoint = `practice/GetQuestionIndexByChapterExam?${queryParams}`;
//     return HttpService.get(apiEndpoint).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

export const getExamDetail = id => {
    let apiEndpoint = `exam/DetailExam?examId=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getGuideQuestion = id => {
    let apiEndpoint = `Question/detailGuideConten?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data && res.data.data && !res.errors ? res.data.data : null;
    }).catch(e => { return false });
}

export const sendExamWorked = payload => {
    let apiEndpoint = `Answer/CreateExerciseExamId`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const saveQuestionExamWorked = payload => {
    let apiEndpoint = `Answer/CreatePraExam`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

// export const resetResultCorrectQuestionExam = id => {
//     let apiEndpoint = `Answer/DeleteAnswerExamId`;
//     return HttpService.post(apiEndpoint, { id }).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

// export const resetResultCorrectQuestionOtherOrThematic = id => {
//     let apiEndpoint = `Answer/DeleteAnswerChapterId`;
//     return HttpService.post(apiEndpoint, { id }).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

// export const getMediaInBookPage = params => {
//     let apiEndpoint = `Book/get-list-page-link?bookId=${params.bookId}&bookPageId=0&pageNo=${params.pageNo}`;
//     return HttpService.get(apiEndpoint).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

// export const getEBooksDetail = id => {
//     let apiEndpoint = `book/${id}`;
//     return HttpService.get(apiEndpoint).then(res => {
//         return res.data ? res.data : null;
//     }).catch(e => { return false });
// }

// export const getMediaRelateInBookPage = (params = {}) => {
//     // let apiEndpoint = `Book/GetListPageLink`;
//     let apiEndpoint = `Book/get-list-page-other_link`;
//     // Book/get-list-page-other_link?bookId=475&BookPageId=626&pageIndex=1&pageSize=6
//     return HttpService.get(apiEndpoint, params).then(res => {
//         return res.data ? res.data : null;
//     }).catch(() => { return false });
// }

// export const getCatInfoOfExercise = id => {
//     let apiEndpoint = `question/GetInformationPractice?bookIndexId=${id}`;
//     return HttpService.get(apiEndpoint).then(res => {
//         return res.data && !res.errors && res.data.data ? res.data.data : null;
//     }).catch(() => { return false });
// }
